import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import cx from "./privacypolicy.module.scss";
import TopNavigation from 'src/pages/NewLandingPage/components/topNavigation/TopNavigation';
import Header from 'src/components/demo-day/header/Header';

function PrivacyPolicy() {
    const [change, setIsChange] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <TopNavigation change={change} />
            <section className={cx.privacypolicy}>
                <Container>
                    <Row className="flex-wrap-reverse">
                        <Col md={12}>
                            <div className={cx.content_main}>
                                <h2>Privacy Policy</h2>
                                <p>
                                    htraction Digital Private Limited (&ldquo;htraction,&rdquo; &ldquo;we,&rdquo; &ldquo;us,&rdquo; or &ldquo;our&rdquo;) is committed to protecting the privacy of its users. This Privacy Policy outlines how we collect, use, share, and protect your information when you access or use our website, platform, or services, especially in light of our evolving feature set, including document uploads, investor-startup matching, and communication capabilities.
                                </p>
                                <p>
                                    By using our website, platform, or services, you agree to the collection and use of information in accordance with this Privacy Policy.
                                </p>

                                <h2>1. Information We Collect</h2>
                                <h3>1.1 Personal Information</h3>
                                <ul>
                                    <li>Full name</li>
                                    <li>Email address</li>
                                    <li>Phone number</li>
                                    <li>Educational and professional details</li>
                                    <li>Role (e.g., entrepreneur, investor, mentor)</li>
                                    <li>Company name and incorporation details</li>
                                    <li>Business stage, revenue information, and registration status</li>
                                </ul>

                                <h3>1.2 Business & Sensitive Information</h3>
                                <ul>
                                    <li>Pitch decks and business plans</li>
                                    <li>Cap table information</li>
                                    <li>Fundraising needs and investment history</li>
                                    <li>Uploaded documents and media</li>
                                    <li>IP-related information about products or services</li>
                                    <li>Program/cohort applications</li>
                                </ul>

                                <h3>1.3 Usage Data</h3>
                                <ul>
                                    <li>Device and browser type</li>
                                    <li>IP address</li>
                                    <li>Pages visited and time spent</li>
                                    <li>User activity on the platform</li>
                                </ul>

                                <h3>1.4 Tracking Technologies</h3>
                                <p>We use cookies and similar tracking technologies to personalize your experience, analyze usage, and improve our services.</p>

                                <h2>2. How We Use Your Information</h2>
                                <p>We use the collected information to:</p>
                                <ul>
                                    <li>Operate and improve the platform</li>
                                    <li>Provide matchmaking between startups and investors/incubators/mentors</li>
                                    <li>Score and evaluate startups using AI and manual models</li>
                                    <li>Communicate relevant opportunities from the htraction team</li>
                                    <li>Facilitate program application and evaluation</li>
                                    <li>Analyze aggregate user behavior for improvements</li>
                                    <li>Ensure security and compliance with legal obligations</li>
                                </ul>

                                <h2>3. Confidentiality & Sensitive Data Handling</h2>
                                <p>We treat all pitch decks, fundraising documents, cap tables, and IP-sensitive uploads as confidential business data. Access to this information is granted only to relevant stakeholders:</p>
                                <ul>
                                    <li>Based on user-initiated matchmaking or program applications</li>
                                    <li>As required for evaluation and support by the htraction team</li>
                                </ul>
                                <p>We implement role-based access controls, encryption protocols, and secure storage to safeguard your data.</p>

                                <h2>4. Matching, Scoring, and Platform Engagement</h2>
                                <p>Your data may be used in both automated and manual processes to:</p>
                                <ul>
                                    <li>Match your profile to relevant stakeholders</li>
                                    <li>Generate an AI-driven or mentor-assisted startup score</li>
                                    <li>Surface your venture to investors or incubators (if opted&rsquo;in)</li>
                                    <li>Enable communication and follow-up from htraction or relevant stakeholders</li>
                                </ul>

                                <h2>5. Communications</h2>
                                <p>You may receive communications from htraction team members regarding:</p>
                                <ul>
                                    <li>Platform support</li>
                                    <li>Matchmaking or pitch opportunities</li>
                                    <li>Program invitations and reminders</li>
                                    <li>Feedback or user experience outreach</li>
                                </ul>
                                <p>You can opt out of non-essential communications at any time.</p>

                                <h2>6. Sharing and Disclosure</h2>
                                <p>We do not sell your data. We may share your information:</p>
                                <ul>
                                    <li>With stakeholders (investors, mentors, incubators) when you initiate interactions</li>
                                    <li>With service providers performing tasks on our behalf</li>
                                    <li>With legal authorities when required to comply with applicable law</li>
                                    <li>In the event of a business transfer, merger, or acquisition</li>
                                    <li>As part of our strategic collaborations, we may share limited startup information such as pitch decks, business summaries, funding needs, and other relevant details with selected ecosystem partners who facilitate investor discovery and startup visibility. Such sharing is done to enhance matchmaking opportunities, amplify funding access, and enable investor outreach through third-party networks/platforms. We ensure that these partners are bound by confidentiality obligations and use the data strictly for the intended purpose. No personally identifiable information is shared unless necessary and explicitly permitted by the startup or founder.</li>
                                </ul>

                                <h2>7. Startup Scoring and Evaluation</h2>
                                <p>Our platform includes proprietary scoring algorithms and manual review processes to assess startups on various parameters. These scores may be made visible to investors or incubators as part of:</p>
                                <ul>
                                    <li>Evaluation rounds</li>
                                    <li>Demo day participation</li>
                                    <li>Matching workflows</li>
                                </ul>
                                <p>All scoring models are subject to ongoing refinement, and htraction reserves the right to use anonymized data to improve these models.</p>

                                <h2>8. Your Rights and Choices</h2>
                                <p>Depending on applicable law, you may:</p>
                                <ul>
                                    <li>Request access to your personal data</li>
                                    <li>Ask for corrections or deletion</li>
                                    <li>Withdraw consent where applicable</li>
                                    <li>Object to or restrict processing</li>
                                    <li>Lodge a complaint with a data authority</li>
                                </ul>
                                <p>To exercise these rights, contact: legal@htraction.com</p>

                                <h2>9. Consent and Upload Responsibility</h2>
                                <p>By uploading any content (pitch decks, plans, etc.), you:</p>
                                <ul>
                                    <li>Represent that you have the rights and authority to share such content</li>
                                    <li>Acknowledge that your content may be used for matching, evaluation, and stakeholder engagement</li>
                                    <li>Agree that htraction is not liable for third-party misuse once content is made visible to them through your actions</li>
                                </ul>

                                <h2>10. Data Security & Retention</h2>
                                <p>We use industry-standard security practices including encryption, access controls, and data anonymization where feasible. Data is retained only as long as necessary for the purposes outlined in this policy.</p>

                                <h2>11. Childrens Privacy</h2>
                                <p>Our platform is not intended for use by individuals under the age of 16. If we become aware of such data being collected, it will be deleted immediately.</p>

                                <h2>12. Changes to This Policy</h2>
                                <p>We may update this Privacy Policy periodically. Users will be notified via email or platform notice when material changes are made. Your continued use constitutes acceptance.</p>

                                <h2>13. Contact Us</h2>
                                <p>htraction Digital Private Limited</p>
                                <p>Email: <a href="mailto:legal@htraction.com">legal@htraction.com</a></p>
                                <p>Website: <a href="https://www.htraction.com" target="_blank" rel="noopener noreferrer">www.htraction.com</a></p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
}

export default PrivacyPolicy;
